declare namespace $ {

	type $mol_view__sub_easyreels_user_notify_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_easyreels_user_notify_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_notify['uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_easyreels_user_notify_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_easyreels_user_notify_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_easyreels_user_notify_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $easyreels_user_notify extends $mol_view {
		Icon( ): $mol_icon_bell
		link_title( ): string
		Link_title( ): $mol_view
		Link( ): $mol_link
		Hint( ): $mol_paragraph
		uri( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=notify.view.tree.d.ts.map